export enum PermissionType {
  appAccess = 'Access.TRACKING',
  maintain = 'Tracking.MAINTAIN'
}
